/**
 * Arquetipo "KPIs" — grid de tarjetas con etiqueta, valor grande y descriptor.
 *
 * Los valores numéricos van en mono (IBM Plex Mono): en el resto del portal
 * todo dato técnico o numérico usa mono, así las cifras de dos tarjetas
 * distintas quedan alineadas a la vista.
 */

export interface Kpi {
  label: string
  value: string | number
  /** Línea de contexto debajo del número. */
  hint?: string
  /** Pinta el valor en ámbar o rojo cuando el número es una alerta. */
  tone?: 'default' | 'warn' | 'danger'
}

const TONE: Record<NonNullable<Kpi['tone']>, string> = {
  default: 'text-ink',
  warn: 'text-warn',
  danger: 'text-danger',
}

export default function KpiGrid({ kpis, columns = 4 }: { kpis: Kpi[]; columns?: 3 | 4 | 5 }) {
  return (
    <div
      className="grid gap-4"
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {kpis.map((kpi) => (
        <div key={kpi.label} className="card px-5 py-4">
          <p className="text-meta font-bold uppercase tracking-[0.05em] text-ink-faint">
            {kpi.label}
          </p>
          <p className={`mt-1.5 font-mono text-kpi font-extrabold ${TONE[kpi.tone ?? 'default']}`}>
            {kpi.value}
          </p>
          {kpi.hint && <p className="mt-0.5 text-micro text-ink-muted">{kpi.hint}</p>}
        </div>
      ))}
    </div>
  )
}
